import React from "react";
import { Form, Input } from "antd";
import "./FormInput.scss";

const FormInput = ({
  label,
  name,
  rules,
  placeholder,
  prefix,
  type = "text",
  size = "small",
}) => {
  const InputComponent = type === "password" ? Input.Password : Input;

  return (
    <Form.Item label={label} name={name} rules={rules} className="form-input-component">
      <InputComponent
        size={size}
        placeholder={placeholder}
        prefix={prefix}
      />
    </Form.Item>
  );
};

export default FormInput;
